var checkIntersection = function(entries, observer) {
    entries.forEach(function(entry, index) {
        var target = entry.target;
        if (entry.isIntersecting) {
            if (target.classList.contains('js-async-img')) {
                var isImg = target.tagName == 'IMG' ? true : false;
                loadSources(target, target.dataset, isImg)
            } else {
                target.classList.add('shown');
                target.classList.remove('js-to-show','not-init');
            }
            observer.unobserve(entry.target);
        }
    })
}

function loadSources(elem, sizes, is_img) {
    var img = new Image(),
        src;

    checkWindowWidth(function(){
        src = sizes.srcMob;
    }, function(){
        src = sizes.srcTab;
    }, function(){
        src = sizes.src;
    });

    if (src.length){
        img.onload = function(){
            if (is_img) {
                elem.src = src;
            } else {
                elem.style.backgroundImage = 'url('+src+')';
            }
            elem.classList.remove('js-async-img','not-loaded');
        };
        img.src = src;        
    }
};

function setIntersections(container, className, rootMargin) {
    var container = container || '',
        className = className || '.js-async-img',
        options = {
        rootMargin: rootMargin || '200px 0px 200px 0px',
        threshold: 0.01,
    },
    observer = new IntersectionObserver(checkIntersection, options),
    images = Array.prototype.slice.call(document.querySelectorAll(container +' '+ className));

    if (images.length) {
        images.forEach(function(el){
            observer.observe(el);
        });
    }
};